export { Instrument as JSErrors } from './instrument/index';